/**
 * Rounding modes for money (ADR 060 — Money Type § 2.4). Half-up is the
 * default; half-even is available for GL / aggregate work and the call site says why.
 */
import Decimal from 'decimal.js';

/** A decimal.js rounding mode a `Money` operation accepts. */
export type RoundingMode = typeof Decimal.ROUND_HALF_UP | typeof Decimal.ROUND_HALF_EVEN;

/** Half away from zero — matches Excel, calculators and US sales-tax guidance. The default. */
export const HALF_UP: RoundingMode = Decimal.ROUND_HALF_UP;

/** Banker's rounding — unbiased across many operations. Never a default; name the reason at the call site. */
export const HALF_EVEN: RoundingMode = Decimal.ROUND_HALF_EVEN;
